import { jsx as _jsx } from "react/jsx-runtime";
import { BaseState } from './BaseState';
export default function EmptyState({ icon, title, description, action, className = '' }) {
    return (_jsx(BaseState, { icon: icon, title: title, description: description, action: action, className: className, iconClassName: "text-gray-500", iconContainerClassName: "bg-gray-100 dark:bg-gray-800" }));
}
//# sourceMappingURL=EmptyState.js.map